import './Obrigado.css';
import { useNavigate } from 'react-router-dom'
import { useState } from 'react';
import BannerHomePhone from '../../Banners/BannerHomePhone/BannerHomePhone.js'
import obrigado from '../../../imgs/obrigado.png'

function Obrigado() {
    const navigate = useNavigate();
    
    setTimeout(() => {
        // navigate("/")
    }, 60000);

    return (
        <div className="home">
            <div className='backgroundLateral2'></div>
            <div className='bkgPavoro'>
                <div className='informacoesObrigado'>
                    <div className='informacoes_recebidas'>Muito Obrigado!</div>
                    <h3 className='informacoesH4'>Agradecemos por nos enviar sua opinião.</h3>
                    <p className='pObrigado'>Dessa forma conseguimos melhorar ainda mais nosso atendimento e proporcionar uma excelente experiência.</p>
                    
                    <p className='pObrigado2'>Central de relacionamento<br /><b>falecom@euquerograna.com.br<br />0800 1000 123</b></p>
                    
                    <div className='imgObrigado'><img src={obrigado} /></div>
                    <div className='cb'></div>
                    
                    
                </div>
            </div>
            <div className='backgroundLateral2'></div>
        </div>
    );
}

export default Obrigado;